import { Component, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import {
  GlobalMessageService,
  GlobalMessageType,
  TranslationService,
} from '@spartacus/core'
import { ContactformService } from './contactform.service'
import { BreadcrumbService } from '../../shared/components/breadcrumb/breadcrumb.service'

@Component({
  standalone: false,
  selector: 'app-contactform',
  templateUrl: './contactform.component.html',
  styleUrls: ['./contactform.component.scss'],
})
export class ContactformComponent implements OnInit {
  requestForm: FormGroup
  submitted = false
  maxChars = 500
  contactFormData = {
    areaOfInterestCode: [],
    countryCode: [],
    jobRoleCode: [],
  }

  constructor(
    private formBuilder: FormBuilder,
    private contactformService: ContactformService,
    private breadCrumbService: BreadcrumbService,
    private translate: TranslationService,
    private globalMessageService: GlobalMessageService
  ) {
    this.requestForm = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      companyName: ['', Validators.required],
      companyEmailAddress: [
        '',
        [
          Validators.required,
          Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
        ],
      ],
      jobRoleCode: ['', Validators.required],
      primaryPhoneNumber: [
        '',
        [Validators.required, Validators.pattern('^((\\+91-?)|0)?[0-9]{10}$')],
      ],
      countryCode: ['', Validators.required],
      city: ['', Validators.required],
      postalCode: [
        '',
        [Validators.required, Validators.pattern('^[0-9]{5,6}(?:-[0-9]{4})?$')],
      ],
      areaOfInterestCode: ['', Validators.required],
      comment: ['', [Validators.required, Validators.maxLength(500)]],
    })
  }

  ngOnInit() {
    this.breadCrumbService.setBreadCrumbs([])
    this.translate
      .translate('contactus.contactUs')
      .subscribe((res: string) =>
        this.breadCrumbService.setBreadcrumbTitle(res)
      )

    this.contactformService.getContactForm().subscribe(
      (contactFormData: any) => {
        if (contactFormData && contactFormData.areaOfInterest) {
          this.contactFormData.areaOfInterestCode =
            contactFormData.areaOfInterest
        }
        if (contactFormData && contactFormData.country) {
          this.contactFormData.countryCode = contactFormData.country
        }
        if (contactFormData && contactFormData.jobRole) {
          this.contactFormData.jobRoleCode = contactFormData.jobRole
        }
      },
      (error) => {}
    )
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.requestForm?.controls
  }

  onSubmit() {
    this.submitted = true

    // stop here if form is invalid
    if (this.requestForm.invalid) {
      return
    }
    const formData = new FormData()
    formData.append('firstName', this.requestForm.value?.firstName)

    formData.append('lastName', this.requestForm.value?.lastName)

    formData.append('companyName', this.requestForm.value?.companyName)

    formData.append(
      'companyEmailAddress',
      this.requestForm.value?.companyEmailAddress
    )

    formData.append('jobRoleCode', this.requestForm.value?.jobRoleCode)

    formData.append(
      'primaryPhoneNumber',
      this.requestForm.value?.primaryPhoneNumber
    )
    formData.append('countryCode', this.requestForm.value?.countryCode)
    formData.append('city', this.requestForm.value?.city)
    formData.append('postalCode', this.requestForm.value?.postalCode)
    formData.append(
      'areaOfInterestCode',
      this.requestForm.value?.areaOfInterestCode
    )
    formData.append('comment', this.requestForm.value?.comment)

    this.contactformService.postContact(formData).subscribe(
      (contactdata) => {
        this.requestForm.reset()

        this.submitted = false
        this.globalMessageService.add(
          { key: 'contactus.requestSubmitted' },
          GlobalMessageType.MSG_TYPE_CONFIRMATION,
          10000
        )
      },
      (error) => {}
    )
  }

  onReset() {
    this.submitted = false
    this.requestForm.reset()
  }
}
